import { useEffect, useState } from "react";
import Cookies from "js-cookie";

interface UseCookieOptions {
  pollInterval?: number;
}

export function useCookie(cookieName: string, options: UseCookieOptions = {}) {
  const { pollInterval = 2000 } = options;
  const [value, setValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    const cookieValue = Cookies.get(cookieName);
    setValue(cookieValue);
  }, [cookieName]);

  useEffect(() => {
    const interval = setInterval(() => {
      const cookieValue = Cookies.get(cookieName);
      if (cookieValue !== value) {
        setValue(cookieValue);
      }
    }, pollInterval);

    return () => clearInterval(interval);
  }, [cookieName, value, pollInterval]);

  return value;
}
